import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import { Field } from '@/src/components/RcForm';
import {
  ResponsiveContainer,
  ResponsiveField,
  formButtonList,
} from '@/src/strategies/util';
import { get } from 'lodash';
import React from 'react';
import Animation from 'src/components/Modules-revamp/Animation';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import moduleStyleRender from '../../ModuleStyle';

import FieldInput from '@/src/components/Modules-revamp/FieldInput';
import Text from '@/src/components/Modules-revamp/ImageAndPoster/Text';

import CustomerInformationFields from '@/src/components/Modules-revamp/CustomerInformationFields';
import FieldSelector from '@/src/components/Modules-revamp/FieldSelector';
import SubscriptionFormStyle from '@/src/components/Modules-revamp/SubscriptionFormStyle';
import TermsAndConditions from '@/src/components/Modules-revamp/TermsAndConditions';
import { ContentModuleGroupPreloadingContext } from '@/src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { formAnimationList } from '@/src/strategies/util';
import {
  buttonThemeUuid,
  fontSizeMultiply,
  layoutOption,
  submitButtonText,
  text,
  textAlignment,
  textBoxWidth,
} from '@/src/tools/contentModulesFieldName';
import { checkResponsiveSubscription } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { useI18n } from 'src/hooks/useRouterChange';
import subscriptionRenderTemplate from 'src/strategies/render/subscription';
import { i18nGet } from 'src/tools/tools';
import { useSubscription } from '../../hooks/useSubscription';
type ResponsiveFieldProps = {
  field: ResponsiveField | ResponsiveField[];
  disabled?: boolean;
  options?: Array<{ label: string; value: any }>;
  hasModal?: boolean;
  modalFunc?: any;
  title?: string;
  required?: boolean;
};
const subscriptionRenderComponent = (
  data: ResponsiveFieldProps,
  breakpoint: any,
  extra: any,
) => {
  const { checkSubmitButtonText, checkText } = checkResponsiveSubscription();
  const { buttons, animations, hoverAnimations, fields, tc, form, getI18n } =
    extra || {};
  const title = `${data?.title}${data?.required ? '*' : ''}`;
  const draggableId = get(form.getFieldsValue(true), 'draggableId');
  const { onSort, onDelete, onModalConfirm, onAdd, onReselect } = extra;
  switch (data.field) {
    case ResponsiveField.LayoutOption: {
      return (
        <FieldSelector
          name={[layoutOption]}
          title={title}
          disabled={data?.disabled}
          options={data?.options || []}
        />
      );
    }
    case ResponsiveField.RichText: {
      return (
        <Text
          breakpoint={breakpoint}
          disabled={data?.disabled}
          validator={checkText}
          fieldNames={{
            text: [text],
            fontSize: [fontSizeMultiply],
            textAlignment: [textAlignment],
            textBoxWidth: [textBoxWidth],
          }}
        />
      );
    }
    case ResponsiveField.SubmitButtonTheme: {
      return (
        <FieldSelector
          title={title}
          name={[buttonThemeUuid]}
          disabled={data?.disabled}
          options={[
            ...formButtonList(buttons),
            { label: getI18n('general.status.none'), value: null },
          ]}
        />
      );
    }
    case ResponsiveField.SubmitButtonText: {
      return (
        <FieldInput
          validator={checkSubmitButtonText}
          breakpoint={breakpoint}
          disabled={data?.disabled}
          title={title}
          name={[submitButtonText]}
        />
      );
    }
    case ResponsiveField.SubscriptionFormStyle: {
      return <SubscriptionFormStyle disabled={data?.disabled} />;
    }
    case ResponsiveField.CustomerInfomationFields: {
      return (
        <CustomerInformationFields
          onSort={onSort}
          onDelete={onDelete}
          onAdd={onAdd}
          draggableId={draggableId}
          fieldsOptions={fields}
          disabled={data?.disabled}
          onModalConfirm={onModalConfirm}
        />
      );
    }
    case ResponsiveField.Terms: {
      return (
        <TermsAndConditions
          disabled={data?.disabled}
          onSort={onSort}
          onDelete={onDelete}
          breakpoint={breakpoint}
          draggableId={draggableId}
          tcsOptions={tc}
          onReselect={onReselect}
        />
      );
    }
    case ResponsiveField.Animation: {
      return (
        <Animation
          disabled={data?.disabled}
          animationOptions={formAnimationList(animations || [])}
          hoverEffectOptions={formAnimationList(hoverAnimations || [])}
        />
      );
    }
    default:
      return;
  }
};
const subscriptionRender = (form: any, breakpoint: any, extra: any) => {
  const values = form.getFieldsValue(true);
  const { handleOnSectionReset, handleOnSectionCopy, getI18n } = extra;
  const list = subscriptionRenderTemplate(values, breakpoint, getI18n);
  const renderComponents = (
    {
      type,
      field,
    }: {
      title?: string;
      titleHide?: boolean;
      type?: ResponsiveContainer;
      field: Array<any>;
    },
    breakpoint: any,
  ) => {
    if (type === ResponsiveContainer.ModuleStyle) {
      return field.map((f) => moduleStyleRender(f));
    } else {
      return field.map((f) =>
        subscriptionRenderComponent(f, breakpoint, extra),
      );
    }
  };
  return (
    <>
      {list.map((item, index) => {
        const component = renderComponents(item, breakpoint);
        return (
          <Wrapper
            key={`${item.title}_${index}`}
            id={`${item?.id}`}
            breakpoint={breakpoint}>
            <BlockTitle
              id={item?.id}
              title={item?.title}
              breakpoint={breakpoint}
              onReset={() =>
                handleOnSectionReset(item?.fields, breakpoint, { item })
              }
              onCopy={() =>
                handleOnSectionCopy(item?.fields, breakpoint, { item })
              }
              dependencies={get(item, 'dependencies')}
              validator={get(item, 'validator')}
            />
            {component}
          </Wrapper>
        );
      })}
    </>
  );
};

export default ({ form, breakpoint, ...extra }: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // TODO: 这里要变
  const {
    handleOnModalConfirm,
    handleOnAdd,
    handleOnDelete,
    handleOnSort,
    fieldsOptions,
    tcsOptions,
    handleOnTcReselect,
  } = useSubscription();
  const { animations, hoverAnimations, buttons } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  return (
    <Field shouldUpdate>
      {() =>
        subscriptionRender(form, breakpoint, {
          onModalConfirm: handleOnModalConfirm,
          onAdd: handleOnAdd,
          onDelete: handleOnDelete,
          onSort: handleOnSort,
          onReselect: handleOnTcReselect,
          getI18n: getI18n,
          form,
          animations,
          hoverAnimations,
          buttons,
          fields: fieldsOptions,
          tc: tcsOptions,
          ...extra,
        })
      }
    </Field>
  );
};
